var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 66,
    viewBox: "0 0 54 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E4E1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8712 27V21",
    stroke: "#3523B9",
    strokeWidth: 1.36003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9993 24L26.7422 24",
    stroke: "#3523B9",
    strokeWidth: 1.36003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.68 28.2799V19.7201C31.68 17.8422 30.1577 16.32 28.2799 16.32H27.1111H20.8889H19.7201C17.8422 16.32 16.32 17.8422 16.32 19.7201V28.2799C16.32 30.1578 17.8422 31.68 19.7201 31.68H28.2799C30.1578 31.68 31.68 30.1578 31.68 28.2799Z",
    stroke: "#3523B9",
    strokeWidth: 1.36003,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7547 45.4359L31.8536 39.3219C31.5038 38.197 30.3068 37.5678 29.1819 37.9176C28.0569 38.2674 27.4278 39.4644 27.7776 40.5893L30.9461 50.7793L27.8993 50.718C27.0099 50.6995 26.1868 51.1864 25.7717 51.9741C25.1285 53.1977 25.6753 54.7069 26.9503 55.2373L33.8872 58.1151C34.504 58.3688 35.1887 58.4003 35.8232 58.203L41.9508 56.2977C43.3217 55.8714 44.1593 54.4919 43.9076 53.0787L42.8106 46.9486C42.5413 45.4454 41.1346 44.4241 39.6223 44.6306L33.7547 45.4359Z",
    fill: "white",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4612 41.8043L22.8199 41.3819",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7652 36.7334L36.4065 37.1559",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5844 31.7176L32.9155 32.9686",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0494 35.3144L23.3098 35.9655",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToHome);
export default __webpack_public_path__ + "static/media/addToHome.2db6426676025cf6141c4d63819d9611.svg";
export { ForwardRef as ReactComponent };